import ExternalLinksBaseHandler from '../external_links_base_handler';

/**
 * Handler for FYP
 */
class ExternalLinksForgotHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksForgotHandler';
    static HandlerName = 'forgot';

    /**
     * Overrides base class
     * @param postMessageData
     */
    executePostMessageAction(postMessageData) {
        switch (postMessageData.ActionId.toString()) {
            case '3':
                if (postMessageData.message === 'close') {
                    this.close();
                }
                break;
            default:
                // maybe should throw an Exception here
                break;
        }
    }


    getHandlerName() {
        return ExternalLinksForgotHandler.HandlerName;
    }

}

export default ExternalLinksForgotHandler;